export default "__VITE_ASSET__DHLFTdvp__"